 import { UValueCalculator } from '../calculators/uvalue-calculator.js';
 import { EnergyCalculator } from '../calculators/energy-calculator.js';


 export function CalculateDoorSummary(widthmm, heightmm, rowsofwindows, climatzone, dooropenings) {



    let doors = new Array();
    doors[0] = new Object();
    doors[0].Name = 'OH1082P';

    doors[1] = new Object();
    doors[1].Name = 'OH1042P';

    doors[2] = new Object();
    doors[2].Name = 'OH1042S';

    let insidetemp = 20;

    let calCalculator = new UValueCalculator();
    //calCalculator.VerifyUValue();
    let energyCalulator = new EnergyCalculator();
    //energyCalulator.VerifyEnergyValue();

	 //refernece door for comparasing
	 let uninsulated = new Object();
     uninsulated.Name = 'OH1042P';
     
     uninsulated.UValue = calCalculator.GetRefValue(heightmm, widthmm);

	 uninsulated.kWy = energyCalulator.CalculateEnergyLoss(uninsulated.Name, climatzone, dooropenings, widthmm, heightmm, insidetemp, uninsulated.UValue);

    for(let i = 0; i<3; i++){
        doors[i].UValue = calCalculator.CalculateUValue(doors[i].Name, widthmm, heightmm, rowsofwindows);
		doors[i].kWy = energyCalulator.CalculateEnergyLoss(doors[i].Name, climatzone, dooropenings, widthmm, heightmm, insidetemp, doors[i].UValue);
		doors[i].kWyDiff = uninsulated.kWy - doors[i].kWy;
    }

    doors = doors.sort((a, b) => a.kWy < b.kWy);

    return doors;

};


// WEBPACK FOOTER //
// ./src/assets/scripts/service/calculation-service.js